import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { stableSort, getSorting, SortableLabel } from './TableUtils'
import { Table, TableHead, TableRow, TableBody, TableCell, Link, Typography, IconButton,
        Tooltip, Button, Grid, CircularProgress, Checkbox, FormControlLabel } from '@material-ui/core'
import Pagination from 'react-bootstrap/Pagination'
import './custom.scss';
import axios from 'axios';
import { format, parseISO } from 'date-fns'
import { handleAxiosError, getAPIUrl } from './AppUtils';
import EditScheduledEventDialog from './EditScheduledEventDialog';
import { Link as RouterLink } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import CreateEventButton from './CreateEventButton';
import { useCheckbox } from './CustomHooks';

const styles = theme => ({
    page: {
        paddingTop: 30,
        paddingBottom: 30,
        paddingLeft: 50,
        paddingRight: 50,
        minHeight: 350,
    },
    button: {
        '&:hover': {
            color: theme.palette.secondary.contrastText,
            textDecoration: 'none'
        },
    },
    tableHeaderCell: {
        minWidth: 120,
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.text.primary,
        fontSize: 14,
        fontWeight: "bold",
        backgroundColor: theme.palette.secondary.main,
        padding: 0,
        '&:last-child': {
          paddingRight: 0,
        },
    },
    tableHeaderRow: {
        height: 30,
    },
    tableRow: {
        height: 40,
        // '&:hover': {
        //     cursor: "pointer",
        // },
    },
    tableCell: {
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: theme.palette.secondary.main,
        padding: "4px, 24px, 4px, 24px",
    },
    pagination:{
        marginTop: 30,
    }
});

function ScheduledEventsPage(props) {
    const { classes, orgSettings } = props;
    const source = axios.CancelToken.source();
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('id');
    const [page, setPage] = React.useState(0);
    const [editEvent, setEditEvent] = useState(undefined);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [events, setEvents] = useState([]);

    const rowsPerPage = 10;
    const numPages = Math.ceil(events.length/rowsPerPage);
    const handleRequestSort = property => event => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    }
    function handlePageChange(pageNum){
        setPage(pageNum);
    }
    function handleEditDialogClose(){
        setEditDialogOpen(false);
        setEditEvent(undefined);
    }
    function handlePageIncrease(){
        if(page<numPages-1){
            setPage(page+1);
        }
    }
    function handlePageDecrease(){
        if(page>0){
            setPage(page-1);
        }
    }
    
    useEffect(() => {
        getEvents();
        return () => {source.cancel("unmount");}
    }, []);
    function getEvents(){
        axios.get(getAPIUrl()+'/scheduledEvents',{cancelToken: source.token})
        .then(response => {
            setEvents(response.data);
        })
        .catch(error=>handleAxiosError(error));
    }
    var filteredEvents = events;
    return (
        <div className={classes.page}>
            <EditScheduledEventDialog
                open={editDialogOpen}
                event={editEvent}
                handleClose={handleEditDialogClose}
                refreshEvents={getEvents}
                edit={true}
                createEventRoute='/createEvent'
                editScheduledEventRoute='/editScheduledEvent'
                createScheduledEventRoute='/createScheduledEvent'
            />
            <Grid style={{marginBottom: 30}} container justify="space-between">
                <CreateEventButton refreshEvents={getEvents}/>
                <Button variant="contained" component={RouterLink} to="/eventsSummary" color="secondary" className={classes.button}>
                    View Events
                </Button>
            </Grid>
            <Table>
                <TableHead>
                    <TableRow className={classes.tableHeaderRow}>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="name"}
                                handleSort={handleRequestSort("name")}
                                label="Name"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="openTime"}
                                handleSort={handleRequestSort("openTime")}
                                label="Open Time"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="closeTime"}
                                handleSort={handleRequestSort("closeTime")}
                                label="Close Time"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="recurrenceString"}
                                handleSort={handleRequestSort("recurrenceString")}
                                label="Recurrence"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="endDate"}
                                handleSort={handleRequestSort("endDate")}
                                label="Recur Until"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            <SortableLabel
                                order={order}
                                active={orderBy==="active"}
                                handleSort={handleRequestSort("active")}
                                label="Active"
                            />
                        </TableCell>
                        <TableCell className={classes.tableHeaderCell} align="center">
                            Edit Event
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {stableSort(filteredEvents, getSorting(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(event=>
                    <TableRow className={classes.tableRow} key={event.id}>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>
                                {event.name}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>
                                {format(parseISO(event.openTime),'yyyy-MM-dd hh:mm a')}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>
                                {format(parseISO(event.closeTime),'yyyy-MM-dd hh:mm a')}
                            </Typography>
                        </TableCell>
                        {/* <TableCell className={classes.tableCell} align="center">
                            <Typography>
                                {event.startDate?format(parseISO(event.startDate),'MMM dd, yyyy'):''}
                            </Typography>
                        </TableCell> */}
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>
                                {event.recurrenceString}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>
                                {event.endDate?format(parseISO(event.endDate),'MMM dd, yyyy'):''}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Typography>
                                {event.active?"Yes":"No"}
                            </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <IconButton
                                fontSize="15"
                                onClick={()=>{
                                    setEditEvent(event);
                                    setEditDialogOpen(true);
                                }}
                            >
                                <EditIcon/>
                            </IconButton>
                        </TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
            <div>
            <Pagination className={classes.pagination}>
                <Pagination.First onClick={()=>handlePageChange(0)}/>
                <Pagination.Prev onClick={handlePageDecrease} disabled={page===0}/>
                {page-10>0?<Pagination.Ellipsis/>:undefined}
                {Array(numPages).fill().map((_, i) => {
                    if(i>page-10 && i<page+10){
                        return(
                            <Pagination.Item key={i} 
                                active={page===i} 
                                onClick={()=>handlePageChange(i)}
                            >
                                {i+1}
                            </Pagination.Item>
                        );
                    }
                })}
                {page+10<numPages-1?<Pagination.Ellipsis/>:undefined}
                <Pagination.Next onClick={handlePageIncrease} disabled={page>=numPages-1}/>
                <Pagination.Last onClick={()=>handlePageChange(numPages-1)}/>
            </Pagination>
            </div>
        </div>
    );
}

export default withStyles(styles)(ScheduledEventsPage);